// libs
import React from 'react';

import { cn } from '@lyearn/style';
// components
import { Stack, Typography } from '@lyearn/ui';
import { Image } from '@/components/Image';
import { getWorkspaceIcon } from '@/modules/lyearn-connect/utils';

// content
import { useLearningContent } from '../context';
// types
import { CreatedByProps } from '../types';

function CreatedBy({
  variant = 'label-02',
  color = 'text-text-secondary',
  className,
}: CreatedByProps) {
  const { content } = useLearningContent();
  if (!content.createdBy && !content.sharedByWorkspace) {
    return null;
  }

  return (
    <Stack alignItems="center">
      {content.sharedByWorkspace ? (
        <Image
          alt={content.sharedByWorkspace.workspaceName}
          className="h-16 w-16 me-6 ms-1"
          height={16}
          objectFit="contain"
          src={getWorkspaceIcon(content.sharedByWorkspace)}
          width={16}
        />
      ) : null}
      <Typography
        className={cn(className, content.sharedByWorkspace ? 'font-bold' : '')}
        color={color}
        data-testid="creator"
        variant={variant}>
        {content.sharedByWorkspace
          ? content.sharedByWorkspace.workspaceName
          : content?.createdBy?.name}
      </Typography>
    </Stack>
  );
}

export default React.memo(CreatedBy);
